import React from 'react';
import { useSelector } from 'react-redux';
import translate from '../translate';
import { Link } from 'react-router-dom';

function AboutShort() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'aboutShort';

    return (
        <div className="about-section theme-light-bg pt-120 pb-130">
        <div className="container">
            <div className="row">
                <div className="col-xl-6">
                    <div className="about-img-wrapper">
                        <img src="assets/img/bg/alpinesoft-office-2.png" alt=""/>
                    </div>
                </div>
                <div className="col-xl-6">
                    <div className="about-content-wrapper pl-80">
                        <div className="section-heading">
                            <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span>
                            <h2 className="heading mb-30">{translate(componentName, 'heading', language)}</h2>
                            <p>{translate(componentName, 'description', language)}</p>
                        </div>
                        <ul className="featured-lists list-unstyled mt-30">
                            <li><i className="fas fa-circle-notch"></i> {translate(componentName, 'feature1', language)}</li>
                            <li><i className="fas fa-circle-notch"></i> {translate(componentName, 'feature2', language)}</li>
                            <li><i className="fas fa-circle-notch"></i> {translate(componentName, 'feature3', language)}</li>
                            <li><i className="fas fa-circle-notch"></i> {translate(componentName, 'feature4', language)}</li>
                        </ul>
                        <Link to="/about" className="btn mt-35">{translate(componentName, 'moreAboutUs', language)} <span></span></Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default AboutShort;